export enum SupportEmailStatus {
  Unread    = 0,
  Read      = 1,
  Replied   = 2,
  Sent      = 3,
  Dismissed = 4,
}

export enum SupportEmailReplyStatus {
  Draft  = 0,
  Sent   = 1,
  Failed = 2,
}

export interface SupportEmailSummary {
  id:          string;
  fromAddress: string;
  fromName?:   string;
  subject:     string;
  bodyText?:   string;
  receivedAt:  string;
  status:      SupportEmailStatus;
  replyId?:    string;
  replyStatus?: SupportEmailReplyStatus;
  replySentAt?: string;
}

export interface SupportEmailReply {
  id:        string;
  messageId: string;
  toAddress: string;
  subject:   string;
  bodyHtml:  string;
  draftedBy: string;
  sentAt?:   string;
  status:    SupportEmailReplyStatus;
  createdAt: string;
}

export interface SupportEmailDetail {
  id:                string;
  externalMessageId: string;
  fromAddress:       string;
  fromName?:         string;
  toAddress:         string;
  subject:           string;
  bodyHtml?:         string;
  bodyText?:         string;
  receivedAt:        string;
  status:            SupportEmailStatus;
  createdAt:         string;
  reply?:            SupportEmailReply;
}

export interface MailboxListResponse {
  items:    SupportEmailSummary[];
  page:     number;
  pageSize: number;
}
